import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router'
import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import DialogContent from '@material-ui/core/DialogContent';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import DialogActions from 'components/DialogActions';
import DialogTransition from 'components/DialogTransition';
import ResponsiveDialogHeader from 'components/ResponsiveDialogHeader';
import SecondaryDialogButton from 'components/SecondaryDialogButton';
import PrimaryDialogButton from 'components/PrimaryDialogButton';
import { Body1 } from 'components/Typography';
import ScheduledCompetencyList from '../ScheduledCompetencyList';
import { scheduledCompetencies } from '../../domain';
import { markPendingCompetenceAsComplete } from 'areas/supervisor/actions';

import {
    closeScheduledCompetenceDialog,
    selectCompetenceAndStartAwarding
} from '../../actions';
import { isDefined } from 'utilities/is';
import { expiryIds } from '../../domain';

import styles from './styles';
import m from 'messages';

const ITEM_HEIGHT = 48;

class PendingCompetenciesDialog extends React.Component {

    state = {
        anchorEL: null,
        selectedCompetence: null,
        expiryDate: null
    };

    handleClose = () => this.props.closeDialog();

    emptyState(siteName) {
        return (
            <Body1 style={{ marginTop: 20, marginBottom: 20 }}>
                {m.competencies.noScheduledCompetencesFor(siteName)}
            </Body1>
        );
    }

    setExpiryDate = (expiryDate) => {
        this.setState({ expiryDate });
    };

    handleCompetencyClicked = (sc) => {
        console.log(JSON.stringify(sc));
        this.setState({ selectedCompetence: sc });
    };

    showExpiryField = () => {
        const { selectedCompetence } = this.state;

        if (!Boolean(selectedCompetence))
            return false;

        return selectedCompetence.expiryID && selectedCompetence.expiryID.toUpperCase() === expiryIds.SPECIFY_EXPIRY_DATE;
    };

    listCompetencies(scheduled, siteNameLabel, siteName) {
        return (
            <div>
                <Body1 paragraph>
                    {m.competencies.theFollowingCompetenciesAreScheduled(siteNameLabel, siteName)}</Body1>
                <Body1 paragraph>
                    {m.competencies.pleaseEnsureTheyAreDelivered}
                </Body1>
                <Divider />
                <ScheduledCompetencyList
                    scheduledCompetencies={scheduled}
                    competencyClicked={this.handleCompetencyClicked}
                    onSecondaryAction={this.handleMenuRequest}
                    handleExpiryDateSet={this.setExpiryDate}
                    shouldShowSecondary={() => true}
                />
            </div>
        );
    }

    markAsComplete = () => {
        const { selectedCompetence } = this.state;
        this.handleMenuClose();
        this.props.handleCompetenceCompletion(selectedCompetence);
    };

    gotoAwardScreen = () => {
        this.props.selectCompetenceAndStartAwarding(this.state.selectedCompetence, this.state.expiryDate);
        this.props.history.push('/competencies');
    };

    handleMenuRequest = (event, sc) => {
        this.setState({
            anchorEl: event.currentTarget,
            selectedCompetence: sc
        });
    };

    handleMenuClose = () => this.setState({ anchorEl: null, selectedCompetence: null });

    handleAward = () => {
        this.gotoAwardScreen();
    };

    contextMenu = () => {
        const { anchorEl, selectedCompetence } = this.state;

        const menuOpen = Boolean(anchorEl);
        const disableAwardMenuItem = selectedCompetence && isDefined(selectedCompetence.award);

        return (
            <Menu
                id="removeMenu"
                anchorEl={anchorEl}
                open={menuOpen}
                onClose={this.handleMenuClose}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: 200,
                    },
                }}>
                <MenuItem
                    disabled={disableAwardMenuItem}
                    onClick={this.markAsComplete}
                    className={this.props.classes.menuItem}>
                    {m.competencies.markAsComplete}
                </MenuItem>
            </Menu>
        );
    }

    canAward() {
        const { selectedCompetence, expiryDate } = this.state;

        if (Boolean(selectedCompetence)) {

            if (this.showExpiryField()) {
                return expiryDate && expiryDate.length > 0;
            }

            return true;
        }

        return false;
    }

    render() {
        const {
            fullScreen,
            open,
            scheduledSiteCompetencies,
            siteName,
            siteNameLabel,
            classes
        } = this.props;

        const isEmpty = scheduledSiteCompetencies.length === 0;
        const title = `Pending ${siteNameLabel}-based competencies`;
        const isFullScreen = !!fullScreen;
        const disableAwardOption = !this.canAward();

        return (
            <Dialog
                fullScreen={isFullScreen}
                open={open}
                onClose={this.handleClose}
                TransitionComponent={DialogTransition}>
                <ResponsiveDialogHeader
                    title={title}
                    showBackIcon={false}
                    handleClose={this.handleClose}
                    fullScreen={isFullScreen}
                />
                <DialogContent className={isFullScreen ? classes.fullScreenContent : ''}>
                    {this.contextMenu()}
                    {isEmpty &&
                        this.emptyState(siteName)
                    }
                    {!isEmpty &&
                        this.listCompetencies(scheduledSiteCompetencies, siteNameLabel, siteName)
                    }
                </DialogContent>
                <DialogActions>
                    {!isFullScreen &&
                        <SecondaryDialogButton onClick={this.handleClose}>
                            {m.general.close}
                        </SecondaryDialogButton>
                    }
                    <PrimaryDialogButton onClick={this.handleAward} disabled={disableAwardOption}>
                        {m.competencies.award}
                    </PrimaryDialogButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = (state) => {
    const { config, competencies, supervisor, location } = state;
    const scheduledSiteCompetencies = scheduledCompetencies(supervisor, location);

    return {
        siteNameLabel: (config.siteLevelName || '').toLowerCase(),
        open: Boolean(competencies.scheduledCompetenceDialogOpen),
        scheduledSiteCompetencies,
        siteName: (location && location.site) ? location.site.siteName : ''
    };
}

const mapDispatchToProps = dispatch => {
    return {
        closeDialog: () => dispatch(closeScheduledCompetenceDialog()),
        handleCompetenceCompletion: (competence) => dispatch(markPendingCompetenceAsComplete(competence)),
        selectCompetenceAndStartAwarding: (competence, expiryDate) => dispatch(selectCompetenceAndStartAwarding(competence, expiryDate))
    }
};

const Routed = withRouter(PendingCompetenciesDialog);
const Styled = withStyles(styles)(Routed);
const Mobile = withMobileDialog()(Styled);
const Connected = connect(mapStateToProps, mapDispatchToProps)(Mobile);

export default Connected;